import styled from 'styled-components';
import { textEllipsis } from '@finect/tabular-utils/textEllipsis';
export var Yields = styled.table.withConfig({
  displayName: "Yields",
  componentId: "sc-ans887-0"
})(["width:100%;margin:0 -5px;color:", ";", " table-layout:fixed;tr th{font-size:80%;font-weight:600;color:", ";}tr td{padding:0 2px;font-size:85%;color:", ";text-align:center;}"], function (_ref) {
  var theme = _ref.theme,
    light = _ref.light;
  return light ? theme.colors.uiD : theme.colors.terciary;
}, textEllipsis, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.uiD;
}, function (_ref3) {
  var theme = _ref3.theme,
    light = _ref3.light;
  return light ? theme.colors.uiD : theme.colors.terciary;
});